import React from "react";
import PropTypes from "prop-types";

const BallScalePulse = ({ customStyles }) => {
    const styles = `la-ball-scale-pulse ${customStyles}`;
    return (
        <div className={styles}>
            <div></div>
            <div></div>
        </div>
    );
};

BallScalePulse.propTypes = {
    customStyles: PropTypes.string,
};

BallScalePulse.defaultProps = {
    customStyles: "",
};

export default BallScalePulse;
